import { BannerPosition } from '@/domain';
import { BannerHeroCarousel } from './BannerHeroCarousel';
import { useBanners } from './useBanners';

/** Dual-mount so mobile and desktop positions share one cached CMS list query. */
export function HomeBannerHero() {
  const mobileBanners = useBanners(BannerPosition.TopBannerMobile);
  const desktopBanners = useBanners(BannerPosition.HomePage);

  return (
    <>
      <BannerHeroCarousel className="lg:hidden" banners={mobileBanners} size="mobile" />
      <BannerHeroCarousel className="hidden lg:block" banners={desktopBanners} size="desktop" />
    </>
  );
}
